import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from '@trendmicro/react-tooltip';


class BarChart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { index, background, width, toolTipContent, data } = this.props;
    return (
      <div className="row fullwidth" style={{ marginTop: '1%' }} key={index}>
        <div className="large-5 medium-5 small-5 columns" style={{ paddingRight: '1%' }}>
          <span className="sub-entity-label" title={data.label}>{data.label}</span>
        </div>
        <div className="large-6 medium-6 small-6 large-md-2 medium-md-2 small-md-2 columns brand-graph-input" >
          <Tooltip
            tooltipClassName="sc-reactTooltip"
            content={toolTipContent}
            placement="right"
          >
            <div
              className="sub-entity-graph-bar"
              style={{ background, width }}
            >
              <div className="sub-entity-graph-label">
                <span className="bold">{data.details[0].pct}</span>
                <span className="sub-entity-weighted-text">OVERLAP</span>
              </div>
            </div>
          </Tooltip>
        </div>
      </div>
    );
  }
}

BarChart.propTypes = {
  toolTipContent: PropTypes.element,
  index: PropTypes.number,
  background: PropTypes.string,
  width: PropTypes.string,
  data: PropTypes.shape({}),
};

export default BarChart;
